import { render } from "./ConversationMessageForm.vue?vue&type=template&id=8326951c"
import script from "./ConversationMessageForm.vue?vue&type=script&lang=js"
export * from "./ConversationMessageForm.vue?vue&type=script&lang=js"
script.render = render

export default script